import {SidebarNudge, type SidebarNudgeProps} from './SidebarNudge'

export type SidebarNudgePartialProps = SidebarNudgeProps

export function SidebarNudgePartial(props: SidebarNudgePartialProps) {
  return <SidebarNudge {...props} />
}
